let env: any = {}
try {
    env = process?.env || {}
}   catch (e) {
    console.warn(e)
}

export default {
    env: env.REACT_APP_DIST_ENV || 'beta',
    isDev: env.REACT_APP_DIST_ENV === 'local',
    isBeta: env.REACT_APP_DIST_ENV === 'beta',
    isProd: env.REACT_APP_DIST_ENV === 'prod',
    isMock: env.REACT_APP_MOCK === 'true'
}
